import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

export class CustomReactPlugin extends ReactPlugin {
    identifier = 'rtdCustomReactPlugin';
}
